/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { createModel } from 'ice';

interface ModelState {
  currentUser: { isUpdate: false },
}

export default createModel({
  state: {
    currentUser: { isUpdate: false },
  } as ModelState,
  reducers: {
    updateCurrentUser(prevState: ModelState, payload) {
      prevState.currentUser = { ...(payload || {}), isUpdate: true };
    },
  },
});
